import { ObjectValues } from 'utils/type-helpers/object-values';

/**
 * 建課／搶課時對老師性別的篩選偏好，非老師本人性別（本人性別見 shared/constants/gender.ts）
 */
export const TEACHER_GENDER_PREFERENCE = {
  MALE: 'male',
  FEMALE: 'female',
  BOTH: 'both',
} as const;

export type TeacherGenderPreference = ObjectValues<
  typeof TEACHER_GENDER_PREFERENCE
>;
